import React from 'react';

/**
 * Button — TestCoachAI design system
 *
 * Variants: primary | accent | secondary | outline | ghost | danger
 * Sizes:    sm | md | lg
 *
 * Usage:
 *   import { Button } from '../ui';
 *   <Button variant="primary" size="md">Start Practice</Button>
 *   <Button variant="accent" icon={<PlayIcon />}>Begin Test</Button>
 *   <Button variant="danger" loading>Deleting…</Button>
 */
export function Button({
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  icon = null,
  iconPosition = 'left',
  children,
  onClick,
  type = 'button',
  className = '',
  ...props
}) {
  const cls = ['tc-btn', `tc-btn--${variant}`, `tc-btn--${size}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={cls}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && <span className="tc-btn__spinner" aria-hidden="true" />}
      {!loading && icon && iconPosition === 'left' && (
        <span aria-hidden="true">{icon}</span>
      )}
      {children && <span>{children}</span>}
      {!loading && icon && iconPosition === 'right' && (
        <span aria-hidden="true">{icon}</span>
      )}
    </button>
  );
}
